import React from "react"
import Button from "../../button"
import { ActionsContainer } from "./styles"

const ActionsCell = ({
  actionCellHandler,
  simpleForm,
  value,
  row: {
    original: { id }
  }
}) => {
  const ViewAction = (id, _simpleForm) => (
    <Button variant="primary" size="small" onClick={(event) => actionCellHandler(event, id, "view")}>
      View
    </Button>
  )
  const UploadAction = (id, _simpleForm) => (
    <Button variant="success" size="small" onClick={(event) => actionCellHandler(event, id, "view")}>
      Upload
    </Button>
  )
  const SignAction = (id, _simpleForm) => (
    <Button variant="success" size="small" onClick={(event) => actionCellHandler(event, id, "sign")}>
      Sign
    </Button>
  )
  const EditAction = (id, simpleForm) => (
    <Button
      variant={simpleForm ? "simpleForm" : "secondary"}
      outlined
      size="small"
      onClick={(event) => actionCellHandler(event, id, "edit")}
    >
      Edit
    </Button>
  )
  const DeleteAction = (id, simpleForm) => (
    <Button
      variant={simpleForm ? "simpleFormDanger" : "danger"}
      outlined={!!simpleForm}
      size="small"
      onClick={(event) => actionCellHandler(event, id, "delete")}
    >
      Delete
    </Button>
  )
  const RemoveAction = (id, simpleForm) => (
    <Button
      variant={simpleForm ? "simpleFormDanger" : "danger"}
      outlined={!!simpleForm}
      size="small"
      onClick={(event) => actionCellHandler(event, id, "remove")}
    >
      Remove
    </Button>
  )
  const AcceptInterviewAction = (id, _simpleForm) => (
    <Button variant="success" size="small" onClick={(event) => actionCellHandler(event, id, "accept_interview")}>
      Accept
    </Button>
  )
  const RescheduleInterviewAction = (id, _simpleForm) => (
    <Button variant="secondary" size="small" onClick={(event) => actionCellHandler(event, id, "reschedule_interview")}>
      Reschedule
    </Button>
  )
  const DeclineInterviewAction = (id, _simpleForm) => (
    <Button variant="danger" size="small" onClick={(event) => actionCellHandler(event, id, "decline_interview")}>
      Decline
    </Button>
  )
  const CancelInterviewAction = (id, _simpleForm) => (
    <Button variant="danger" size="small" onClick={(event) => actionCellHandler(event, id, "cancel_interview")}>
      Cancel
    </Button>
  )
  const OfferPlacementAction = (id, _simpleForm) => (
    <Button variant="success" size="small" onClick={(event) => actionCellHandler(event, id, "offer_placement")}>
      Make Offer
    </Button>
  )
  const DeclinePlacementAction = (id, _simpleForm) => (
    <Button variant="danger" size="small" onClick={(event) => actionCellHandler(event, id, "decline_placement")}>
      Decline
    </Button>
  )
  const AmmendOfferAction = (id, _simpleForm) => (
    <Button variant="success" size="small" onClick={(event) => actionCellHandler(event, id, "ammend")}>
      Amend Offer
    </Button>
  )
  const CancelOfferAction = (id, _simpleForm) => (
    <Button variant="danger" size="small" onClick={(event) => actionCellHandler(event, id, "cancel_offer")}>
      Cancel Offer
    </Button>
  )
  const PdfAction = (id, _simpleForm) => (
    <Button variant="secondary" size="small" onClick={(event) => actionCellHandler(event, id, "pdf")}>
      PDF
    </Button>
  )
  const CsvAction = (id, _simpleForm) => (
    <Button variant="secondary" size="small" onClick={(event) => actionCellHandler(event, id, "csv")}>
      CSV
    </Button>
  )
  const SubmitAction = (id, _simpleForm) => (
    <Button variant="success" size="small" onClick={(event) => actionCellHandler(event, id, "submit")}>
      Submit
    </Button>
  )
  const FilledAction = (id, _simpleForm) => (
    <Button variant="success" size="small" onClick={(event) => actionCellHandler(event, id, "filled")}>
      Mark as Filled
    </Button>
  )
  const UnfulfilledAction = (id, _simpleForm) => (
    <Button variant="secondary" size="small" onClick={(event) => actionCellHandler(event, id, "unfulfilled")}>
      Filled
    </Button>
  )
  const SearchAction = (id, _simpleForm) => (
    <Button variant="secondary" size="small" onClick={(event) => actionCellHandler(event, id, "search")}>
      Search
    </Button>
  )
  const ReinviteAction = (id, _simpleForm) => (
    <Button variant="success" size="small" onClick={(event) => actionCellHandler(event, id, "reinvite")}>
      Re-Invite
    </Button>
  )
  const ContinueAction = (id, _simpleForm) => (
    <Button variant="success" size="small" onClick={(event) => actionCellHandler(event, id, "continue")}>
      Continue
    </Button>
  )
  const ConfirmAction = (id, _simpleForm) => (
    <Button variant="success" size="small" onClick={(event) => actionCellHandler(event, id, "confirm")}>
      Confirm
    </Button>
  )

  const actionTypes = {
    view: ViewAction,
    upload: UploadAction,
    sign: SignAction,
    edit: EditAction,
    delete: DeleteAction,
    remove: RemoveAction,
    accept_interview: AcceptInterviewAction,
    decline_interview: DeclineInterviewAction,
    reschedule_interview: RescheduleInterviewAction,
    cancel_interview: CancelInterviewAction,
    offer_placement: OfferPlacementAction,
    decline_placement: DeclinePlacementAction,
    ammend: AmmendOfferAction,
    cancel_offer: CancelOfferAction,
    pdf: PdfAction,
    csv: CsvAction,
    submit: SubmitAction,
    filled: FilledAction,
    unfulfilled: UnfulfilledAction,
    search: SearchAction,
    reinvite: ReinviteAction,
    continue: ContinueAction,
    confirm: ConfirmAction
  }

  if (Array.isArray(value) && id !== undefined && actionCellHandler !== undefined) {
    return (
      <ActionsContainer simpleForm={simpleForm}>
        {value.map((action) => {
          const Action = actionTypes[action]
          return Action ? Action(id, simpleForm) : null
        })}
      </ActionsContainer>
    )
  } else {
    return ""
  }
}

export default ActionsCell
